import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useMemo } from "react";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { twMerge } from "tailwind-merge";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
var FinanceQualified = function FinanceQualified(_ref) {
  var _posts_data$slice;
  var posts_data = _ref.posts_data,
    filters = _ref.filters;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var layoutOptions = useMemo(function () {
    return {
      hideOrangeHeadBtn: true,
      hideFooter: true,
      hideSideMenue: false,
      hideAppBanner: true,
      mobileNoLogo: true,
      hideHeaderOnmobile: true,
      headHideLinks: true,
      custommobileHeader: /*#__PURE__*/React.createElement("div", {
        className: "flex items-center px-4 py-5 bg-white border-b border-b-gray-gainsboro border-solid min-h-[70px]"
      })
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, layoutOptions, /*#__PURE__*/React.createElement("section", {
    className: twMerge("bg-gray-lotion min-h-[calc(100vh-70px)] pt-8 lg:max-w-[900px] xl:max-w-[1158px] mx-auto lg:bg-white lg:px-0 px-4 md:pb-10", (posts_data === null || posts_data === void 0 ? void 0 : posts_data.length) === 0 ? "pt-16" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/quialified.png",
    alt: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-4 mb-7 flex flex-col items-center gap-3"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary font-bold text-2xl md:text-3xl text-center"
  }, t("eligible_financing_2", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-center text-primary font-semibold text-base md:text-lg"
  }, t("probability_financing_application_accepted_high", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("h3", {
    className: "text-primary text-center text-lg md:text-2xl font-bold leading-6 mt-5 mb-2"
  }, t("recommend_these_cars", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("section", {
    className: "flex gap-4 overflow-scroll snap-x snap-mandatory lg:overflow-hidden"
  }, posts_data && (posts_data === null || posts_data === void 0 ? void 0 : (_posts_data$slice = posts_data.slice(0, 4)) === null || _posts_data$slice === void 0 ? void 0 : _posts_data$slice.map(function (post) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "w-full min-w-[300px] snap-center lg:min-w-[unset] min-h-full"
    }, /*#__PURE__*/React.createElement(ModernCard, {
      post: post,
      hideFavIcon: true,
      page: "page",
      sectionType: "eligibility"
    })));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-full lg:max-w-[345px] mx-auto px-2 mt-6"
  }, /*#__PURE__*/React.createElement("button", {
    className: twMerge("bg-primary border-none outline-none text-white text-sm font-bold rounded w-full p-3 leading-8 lg:mt-8 cursor-pointer", (posts_data === null || posts_data === void 0 ? void 0 : posts_data.length) === 0 ? "mt-0 lg:mt-0" : ""),
    onClick: function onClick() {
      var url = "/filters" + "?" + filters;
      navigateTo(url);
    }
  }, t("see_cars", {
    ns: "web_common"
  }))))));
};
export default FinanceQualified;